import { render, staticRenderFns } from "./otp.vue?vue&type=template&id=7a8654e2"
import script from "./otp.vue?vue&type=script&lang=js"
export * from "./otp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\web\\rcms\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a8654e2')) {
      api.createRecord('7a8654e2', component.options)
    } else {
      api.reload('7a8654e2', component.options)
    }
    module.hot.accept("./otp.vue?vue&type=template&id=7a8654e2", function () {
      api.rerender('7a8654e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/auth/otp.vue"
export default component.exports